import { combineReducers } from 'redux';
import {
  commonReducers,
  authReducers,
  departmentReducers,
  notificationReducers,
  designationReducers,
  sidebarReducers,
  qualificationReducers,
  trainingCertificateReducers,
  dropdownMasterReducers,
  positionReducers,
  mrfReducers,
  mrfInterviewReducers,
  locationReducers,
  employeeReducers,
  shiftManagementReducers,
  emailTemplateReducers,
  onboardingReducers,
  candidateReducers,
  leaveReducers,
  policiesReducers,
  branchReducers,
  holidaysReducers,
  attendanceDashboardReducers,
  permissionReducers,
  rolesReducers,
  attendanceCorrectionReducers,
  ApprovalManagementReducers,
  payrollReducers,
  otherAttendanceReducers,
  communityReducers,
  clientReducers,
  feedbackReducers,
  kudosReducers,
  travelAndClaimReducers,
  financialYearReducers,
  pmsReducers,
  dashboardReducers,
  taskManagementReducers,
  assetsManagementReducers,
  separationReducers,
  ticketManagementReducers,
  MoodRatingReducers, 
  ReportReducers,
  bulkUploadReducers
} from './reducers';


const appReducer = combineReducers({
  notification: notificationReducers,
  common: commonReducers,
  auth: authReducers,
  department: departmentReducers,
  designation: designationReducers,
  notifications: notificationReducers,
  emailtemplate: emailTemplateReducers,
  sidebar: sidebarReducers,
  onboarding: onboardingReducers,
  shift: shiftManagementReducers,
  department: departmentReducers,
  designation: designationReducers,
  sidebar: sidebarReducers,
  qualification: qualificationReducers,
  trainingCertificate: trainingCertificateReducers,
  dropdownMaster: dropdownMasterReducers,
  position: positionReducers,
  mrf: mrfReducers,
  location: locationReducers,
  employee: employeeReducers,
  mrfInterview: mrfInterviewReducers,
  candidate: candidateReducers,
  leave: leaveReducers,
  policies: policiesReducers,
  branch: branchReducers,
  holiday: holidaysReducers,
  attendanceDashboard: attendanceDashboardReducers,
  permission: permissionReducers,
  roles: rolesReducers,
  attendanceCorrection: attendanceCorrectionReducers,
  approvalManagement: ApprovalManagementReducers,
  payroll: payrollReducers,
  otherAttendance: otherAttendanceReducers,
  community: communityReducers,
  client: clientReducers,
  feedback: feedbackReducers,
  kudos: kudosReducers,
  travelAndClaim: travelAndClaimReducers,
  financialYear: financialYearReducers,
  pms: pmsReducers,
  dashboard: dashboardReducers,
  taskManagement: taskManagementReducers,
  assetsManagement: assetsManagementReducers,
  separation: separationReducers,
  ticketManagement:ticketManagementReducers,
  moodRating:MoodRatingReducers,
  reports:ReportReducers,
  bulkUpload:bulkUploadReducers

});

const rootReducer = (state, action) => {
  const { type, payload } = action;
  let newState;

  if (type === 'APP_INIT') {
    newState = { ...state, internal: {} };
  } else if (type === 'RELOAD_STORE') {
    newState = { ...payload };
  } else if (type === 'CLEAR_INTERNAL_STORE') {
    newState = { routing: { ...state.routing } };
  }

  return appReducer(newState || state, action);
};

export default rootReducer;
